import { formatBytes, type PendingAttachment } from '../attachments'

interface Props {
  items: PendingAttachment[]
  onRemove: (index: number) => void
}

/**
 * Compact chip row above the textarea. Each chip shows
 *
 *     <icon> <filename> · <size>  ×
 *
 * with a click target on the × to remove the attachment from the
 * pending list. Hides itself when the list is empty so the input area
 * doesn't reserve vertical space for nothing.
 *
 * Mirrors `_renderAttachmentChips` in the Obsidian plugin's main.js
 * exactly. The wire shape both surfaces send is identical.
 */
export function ConciergeAttachmentChips({ items, onRemove }: Props) {
  if (!items.length) return null

  return (
    <div className="concierge-attachment-chips">
      {items.map((a, i) => (
        <span
          key={`${a.filename}-${i}`}
          className="concierge-attachment-chip"
          title={a.filename}
        >
          <span className="concierge-attachment-chip-icon">
            {a.kind === 'image' ? '🖼' : '📄'}
          </span>
          <span className="concierge-attachment-chip-label">
            {a.filename || '(unnamed)'}
          </span>
          <span className="concierge-attachment-chip-size">
            {formatBytes(a.size)}
          </span>
          <button
            type="button"
            className="concierge-attachment-chip-x"
            onClick={() => onRemove(i)}
            aria-label={`Remove ${a.filename || 'attachment'}`}
          >
            ×
          </button>
        </span>
      ))}
    </div>
  )
}
